import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';

import { ILinkProps, Link } from '../../../Link';

import * as styles from './styles.css';

type TNewbuildingsLinkProps = Omit<ILinkProps, 'children'>;

export function NewbuildingsLink({ url }: TNewbuildingsLinkProps) {
  return (
    <div className={styles['link']}>
      <Link url={url} target="blank">
        <InlineText2 color="primary_100">Смотреть все ЖК от застройщика</InlineText2>
      </Link>
    </div>
  );
}
